import { Spinner } from '@/components/shared';
import { environment } from '@/data/constants';
import { IViewResolverTheme, ThemeProvider } from '@ldp/view-resolver-utils';
import {
  TPharmacistOwners,
  TPharmacistOwnersGrouped,
} from '@/components/pharmaprix-pharmacist-owners/pharmaprix-pharmacist-owners.interface';
import React, { lazy, useEffect, useState, type ComponentType } from 'react';
import { useIntl } from 'react-intl';
import { themeTokens } from '../../__mocks__/data/header-footer-design-data';
import PharmaprixOwnersFooter from '@/components/pharmaprix-owners-footer';
import PharmaprixOwnersHeader from '@/components/pharmaprix-owners-header';
import PharmaprixOwnersContent from '@/components/pharmaprix-owners-content';

import styles from './pharmaprix-pharmacist-owners.module.scss';

const PharmaprixPharmacistOwners: React.FC<TPharmacistOwners> = ({ pharmacyOwnersDetailsList }) => {
  const { locale } = useIntl();
  const { PRODUCTION, LOWER } = environment;
  const theme: IViewResolverTheme = {
    name: 'sdm-web',
    version: 'latest',
    env: process.env.NEXT_PUBLIC_VIEW_RESOLVER_ENV === PRODUCTION ? PRODUCTION : LOWER,
  };
  const [ViewResolverSDM, setViewResolverSDM] = useState<ComponentType<any> | null>(null);
  const groupedPharmacies = pharmacyOwnersDetailsList?.reduce<TPharmacistOwnersGrouped>((acc, pharmacy) => {
    const { city } = pharmacy;
    if (!acc[city]) {
      acc[city] = [];
    }
    acc[city].push(pharmacy);
    return acc;
  }, {});

  useEffect(() => {
    if (typeof window !== 'undefined') {
      // @ts-ignore
      setViewResolverSDM(lazy(() => import('ldpViewResolverSdm/Resolver')));
    }
  }, []);

  if (!ViewResolverSDM) {
    return <Spinner />;
  }

  return (
    <ViewResolverSDM
      themeTokens={themeTokens}
      PageLoadingFallback={() => <Spinner />}
      locale={locale}
      env={process.env.NEXT_PUBLIC_VIEW_RESOLVER_ENV}
    >
      <ThemeProvider theme={theme}>
        <div className={styles.ownersPageWrapper}>
          <PharmaprixOwnersHeader />
          <PharmaprixOwnersContent groupedPharmacies={groupedPharmacies} />
          <PharmaprixOwnersFooter />
        </div>
      </ThemeProvider>
    </ViewResolverSDM>
  );
};

export default PharmaprixPharmacistOwners;
